var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M24.12.5H1.88C1.117.5.5 1.117.5 1.88v22.24c0 .762.617 1.38 1.38 1.38h11.973v-9.68h-3.26v-3.773h3.26V9.26c0-3.227 1.972-4.983 4.853-4.983 1.38 0 2.566.1 2.91.147V7.8h-2c-1.56 0-1.866.75-1.866 1.843v2.406h3.734L21 15.83h-3.25v9.67h6.37c.762 0 1.38-.617 1.38-1.38V1.88c0-.763-.617-1.38-1.38-1.38"}));
}

FacebookIcon.defaultProps = {"id":"Layer_1","viewBox":"0 0 26 26"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
